import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ActiveActionType,
  ActiveFlowType,
  EditorStateType,
  ExpandedClaimType,
  SettingsActionType,
  TextAnalysisResultsType,
} from '@src/types/main';
import { generateAttributes } from '@src/utils/editor-helpers';

const initialState: EditorStateType = {
  isTextTouched: false,
  activeFlow: '',
  activeAction: '',
  settings: {
    topK: 10,
    distanceThreshold: 0.8,
  },
  textAnalysisResults: {
    message: '',
    claims: [],
  },
  enrichedTextAnalysisResults: {
    message: '',
    claims: [],
  },
  expandedClaim: null,
};

const editorSlice = createSlice({
  name: 'editor',
  initialState,
  reducers: {
    setActiveFlow(state, action: PayloadAction<ActiveFlowType>) {
      state.activeFlow = action.payload;
    },
    setActiveAction(state, action: PayloadAction<ActiveActionType>) {
      state.activeAction = action.payload;
    },
    setSettings(state, action: PayloadAction<SettingsActionType>) {
      const { topK, distanceThreshold } = action.payload;
      state.settings.topK = topK;
      state.settings.distanceThreshold = distanceThreshold;
    },
    setIsTextTouched(state, action: PayloadAction<boolean>) {
      state.isTextTouched = action.payload;
    },
    setTextAnalysisResults(
      state,
      action: PayloadAction<TextAnalysisResultsType>
    ) {
      state.textAnalysisResults = action.payload;
    },
    setEnrichedTextAnalysisResults(
      state,
      action: PayloadAction<TextAnalysisResultsType>
    ) {
      const enrichedClaims = generateAttributes(
        action.payload,
        state.activeAction
      );

      state.enrichedTextAnalysisResults = {
        message: action.payload.message,
        claims: enrichedClaims,
      };
    },
    setExpandedClaim(state, action: PayloadAction<ExpandedClaimType>) {
      state.expandedClaim = action.payload;
    },
    resetResults(state) {
      state.textAnalysisResults.message = '';
      state.textAnalysisResults.claims = [];
      state.enrichedTextAnalysisResults.message = '';
      state.enrichedTextAnalysisResults.claims = [];
      state.expandedClaim = null;
    },
  },
});

export const {
  setActiveFlow,
  setActiveAction,
  setSettings,
  setIsTextTouched,
  setTextAnalysisResults,
  setEnrichedTextAnalysisResults,
  setExpandedClaim,
  resetResults,
} = editorSlice.actions;

export default editorSlice.reducer;
